import { Component, OnDestroy, OnInit, Optional } from '@angular/core';
import { NbDialogRef, NbMenuItem, NbMenuService } from '@nebular/theme';
// import { Section } from '@urbannex/kwikstore-visual-editor/lib/editor-container/editor-model';
import { ContentStatusEnum, MenuItemContext, RendererType, Section } from '../../../../../editor-container/editor-model';
import { ContentElementEnum, ContentEnum, GridCell, GridCellClass, GridCellElement, GridCellFooter, GridCellHeading, GridCellImage, GridCellText, GridLayoutEnum } from '@urbannex/storethemes';
import { EditorTemplateService } from '../../../../editor-template.service';
import { ContentElement } from '@urbannex/storethemes';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { SectionBuilderStoreService } from '../../../../sections-editor/shared-section-builder/section-builder-store.service';
import { BehaviorSubject, Subject, map, takeUntil } from 'rxjs';
import { getTarget } from '@urbannex/view-containers';
import { PreviewEditStoreService } from '../../../../../services/preview-edit-store.service';
import { EditState } from '../../../../../model';

export interface MenuItemPlaceHolder {
  cellId: string;
  item: NbMenuItem;
}

@Component({
  selector: 'ngx-grid-input-dialog',
  templateUrl: './grid-input-dialog.component.html',
  styleUrls: ['./grid-input-dialog.component.scss']
})
export class GridInputDialogComponent implements OnInit, OnDestroy {

  menuItemPlaceHolders: MenuItemPlaceHolder[] = [];
  title: string;
  layoutClass: string;
  contentType: any;
  selectedCell: GridCell;
  cellElements: GridCellElement<any>[] = [];
  rendererType = RendererType.GRID;

  section: Section;

  status: ContentStatusEnum;

  status$ = new BehaviorSubject(null);

  gridCells: GridCell[] = [];

  screenSize = "default"

  menuItems: NbMenuItem[] = [
    {
      title: "Cells",
      group: true
    }
  ];

  hasLoaded = false;
  svgData = `<svg xmlns="http://www.w3.org/2000/svg" width="200" height="200">
                   <rect width="200" height="200" fill="#cccccc" />
                   <text x="50%" y="50%" font-size="20" text-anchor="middle" fill="#777777" dy=".3em">Placeholder</text>
                 </svg>`;
  encodedSvg = encodeURIComponent(this.svgData);

  svgUrl = `data:image/svg+xml,${this.encodedSvg}`;

  svgBackground: SafeStyle;

  private destroy$ = new Subject<void>();

  canSave = false;



  constructor(
    @Optional() protected ref: NbDialogRef<GridInputDialogComponent>,
    private editorTemplateService: EditorTemplateService,
    private sanitizer: DomSanitizer,
    private sectionBuilderStoreService: SectionBuilderStoreService,
    private menuService: NbMenuService,
    private previewEditStoreService: PreviewEditStoreService) { }



  ngOnInit(): void {
    // this.createGridCells(this.layoutClass);
    this.svgBackground = this.sanitizer.bypassSecurityTrustStyle(`url("${this.svgUrl}")`);
    this.createSection(this.layoutClass);
    /* this.section$.pipe(takeUntil(this.destroy$)).subscribe(section => {
      console.log(section);
        this.section = section
    }); */
    this.sectionBuilderStoreService.section$.subscribe(section => {
      if (section != undefined) {
        console.log(section);
        this.section = section;
        if (this.section.status != undefined) {
          this.status$.next(this.section.status);
        } else {
          this.status$.next(ContentStatusEnum.CTNT_IN_PROGRESS);
        }
      }

    })
  }

  createSection(layoutClass: string) {
    let templateContentId;

    const gridCells = [];
    switch (layoutClass) {
      case "grid-3":
        templateContentId = "GRID_3_CNT";
        // this.section.title = null;
        break;
      case "grid-4":
        templateContentId = "GRID_4_CNT";
        // this.section.title = null;
        break;
      case "grid-5":
        templateContentId = "GRID_5_CNT";
        // gridCells = this.createGridCells("grid-5");
        // this.section.title = null;
        break;
      case "grid-6":
        templateContentId = "GRID_6_CNT";
        // gridCells = this.createGridCells("grid-6");
        // this.section.title = null;
        break;
      case "grid-7":
        templateContentId = "GRID_7_CNT";
        // gridCells = this.createGridCells("grid-7");
        break;
      case "grid-8":
        templateContentId = "GRID_8_CNT";
        // gridCells = this.createGridCells("grid-8");
        // this.section.title = null;
        break;
      case "grid-9":
        templateContentId = "GRID_9_CNT";
        // gridCells = this.createGridCells("grid-9");
        // this.section.title = null;
        break;

      default:
        templateContentId = "GRID_3_CNT";
        break;
    }
    this.editorTemplateService.getTemplate(templateContentId).subscribe(resp => {
      let section;
      const data = resp["data"];
      console.log(data);
      // Set the temporary ids
      section = this.setTemporaryIds(data["section"]);
      // Set the section Status;
      section.status = ContentStatusEnum.CTNT_IN_PROGRESS;
      // Set the status for each cell
      section = this.setCellContentStatus(section);
      // Set the placeholder images
      section = this.setPlaceholderImages(section)
      // Create the menu;
      this.gridCells = section.sectionData.gridOptions.gridCells;
      console.log(section.sectionData.layoutClass);
      // Convert the layoutClass to its value
      section.sectionData.layoutClass = this.getLayoutClassValue(section.sectionData.layoutClass);
      // section.sectionData.layoutClass = GridLayoutEnum[section.sectionData.layoutClass];
      console.log(section);
      this.selectedCell = this.gridCells[0]
      this.createMenu(this.gridCells);
      setTimeout(() => {
        this.hasLoaded = true;
        this.sectionBuilderStoreService.init(section)
      }, 100);

    })

    // this.section.sectionData.gridOptions.gridCells = gridCells;
  }

  getLayoutClassValue(rawLayoutyClass) {
    let layoutValue;
    if ((rawLayoutyClass).includes(".")) {
      const enumKey = rawLayoutyClass.split('.')[1] as keyof typeof GridLayoutEnum;
      layoutValue = GridLayoutEnum[enumKey];
    } else if (GridLayoutEnum[layoutValue] != undefined) {
      layoutValue = ContentEnum[layoutValue]
    } else {
      layoutValue = layoutValue;
    }
    return layoutValue;
  }

  generateUniqueId() {
    const timestamp = Date.now(); // Get the current timestamp in milliseconds
    const randomNum = Math.floor(Math.random() * 1000000); // Generate a random number for extra uniqueness
    return `id-${timestamp}-${randomNum.toString(36)}`; // Combine timestamp and random number, convert to base-36
  }

  // Example usage
  // const uniqueId = generateUniqueId();
  // console.log(uniqueId); // Output: id-1635357382943-3f5x9j

  createGridCells(layoutClass: string) {
    const gridCells = [];

    return gridCells;
  }

  setTemporaryIds(section: Section): Section {
    section.sectionId = "temp-section-" + this.generateUniqueId();
    const gridCells: GridCell[] = section.sectionData.gridOptions.gridCells;
    gridCells.forEach(gridCell => {
      gridCell.cellId = "temp-cell-" + this.generateUniqueId();
      const className: string = gridCell.className;
      gridCell.className = GridCellClass[className];
      const contentElements: ContentElement[] = gridCell.contentElements;
      contentElements.forEach(cntEl => {
        cntEl.elId = "temp-el-" + this.generateUniqueId();
      })
    })
    return section
  }
  setCellContentStatus(section: Section): Section {
    const gridCells: GridCell[] = section.sectionData.gridOptions.gridCells;
    gridCells.forEach(gridCell => {
      gridCell.status = ContentStatusEnum.CTNT_IN_PROGRESS;
    })
    return section
  }
  /**
   * PRODUCT = "Product Content",
    CATEGORY = "Category Content",
    PROMO_TEXT = "Promotional Text",
    CALL_TO_ACTION = "Call To Action",
    BLOG_ARTICLE_LINK = "Blog Article Link",
    CATEGORY_LINK = "Category Link",
    PRODUCT_LINK = "Product Link",
    BANNER = "Banner",
    HEADLINE = "Headline",
    SUB_HEADLINE = "Sub Headline",
    GALLERY = "Gallery",
    PRODUCT_CLASSIFICATION = "Product Classification",
    PRODUCT_ID = "Product Identification",
    PRODUCT_STD_FEATS = "Product Standard Features",
    PRODUCT_SELC_FEATS = "Product Selectable Features",
    PRODUCT_PRICING = "Product Price",
    PRODUCT_RATING = "Product Rating",
    PRODUCT_DIMENSIONS = "Product Rating",
    PRODUCT_PACKAGING = "Product Packaging",
    PRODUCT_SHORT_DESC = "Product Short Description",
    PRODUCT_LONG_DESC = "Product Long Description",
    PRODUCT_REVIEWS = "Product Reviews",
    PRODUCT_ADD_TO_CART = "Add To Cart",
    PRODUCT_SHARE = "Product Share",
    PRODUCT_DELIVERY = "Delivery",
    PRODUCT_INVENTORY = "Inventory",
    PRODUCT_VARIANT = "Product Variant",
    GENERAL_TEXT = "General Text",
    SHOPPINGCART = "Shopping Cart",
    BLOG_HEADER = "Blog Header",
    BLOG_SUMMARY = "Blog Summary",
    BLOG_MAIN = "Blog Main",
    BLOG_SHARE = "Blog Share",
    BLOG_COMMENTS = "Blog Comments",
    BLOG_IMAGE = "Blog Image",
    NAV_LIST = "Navigation List",
    PRODUCT_CELL = "Product Cell",
    HERO_IMAGE = "Hero Image"
   */
  /**
   *
   * @param section
   * @returns
   */
  setPlaceholderImages(section: Section) {
    const gridCells: GridCell[] = section.sectionData.gridOptions.gridCells;
    gridCells.forEach(gridCell => {
      console.log(gridCell.contentEnum);
      const cellCntEnum = this.getGridCellContentEnum(gridCell);
      console.log(cellCntEnum)
      switch (cellCntEnum) {
        case "Banner":
          /* const svgBackground = `data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%22200%22 height=%22200%22%3E%3Crect width=%22200%22 height=%22200%22 fill=%22%23cccccc%22/%3E%3Ctext x=%2250%25%22 y=%2250%25%22 font-size=%2220%22 text-anchor=%22middle%22 fill=%22%23777777%22 dy=%22.3em%22%3EPlaceholder%3C/text%3E%3C/svg%3E`;

          const svgBackground = `data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="200" height="200"%3E%3Crect width="200" height="200" fill="%23cccccc"/%3E%3Ctext x="50%25" y="50%25" font-size="20" text-anchor="middle" fill="%23777777" dy=".3em"%3EPlaceholder%3C/text%3E%3C/svg%3E`; */

          // let svgBackground = "data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%22200%22 height=%22200%22%3E%3Crect width=%22200%22 height=%22200%22 fill=%22%23cccccc%22/%3E%3Ctext x=%2250%25%22 y=%2250%25%22 font-size=%2220%22 text-anchor=%22middle%22 fill=%22%23777777%22 dy=%22.3em%22%3EPlaceholder%3C/text%3E%3C/svg%3E";
          // gridCell.imgSrc = gridCell.imgSrc;
          // svgBackground = this.sanitizer.bypassSecurityTrustStyle(`url("${svgBackground}")`);
          // gridCell.imgSrc = "data:image/svg+xml;utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2275%22%20height%3D%2250%22%20style%3D%22position%3Arelative%22%3E%3Ccircle%20cx%3D%2225%22%20cy%3D%2225%22%20r%3D%2225%22%20fill%3D%22red%22%20%2F%3E%3CforeignObject%20style%3D%22width%3A%20100%25%3B%20height%3A%20100%25%22%3E%3Chtml%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml%22%3E%3Cstyle%3E.x%20%7Bposition%3A%20absolute%3Bbackground%3A%20url(%22data%3Aimage%2Fsvg%2Bxml%3Butf8%2C%253Csvg%2520xmlns%253D'http%253A%252F%252Fwww.w3.org%252F2000%252Fsvg'%2520width%253D'100'%2520height%253D'50'%253E%253Ccircle%2520cx%253D'50'%2520cy%253D'25'%2520r%253D'25'%2520fill%253D'blue'%252F%253E%253C%252Fsvg%253E%22)%3B%20width%3A%20100%25%3B%20height%3A%20100%25%3B%7D%3C%2Fstyle%3E%3Cdiv%20class%3D%22x%22%3E%3C%2Fdiv%3E%3C%2Fhtml%3E%3C%2FforeignObject%3E%3C%2Fsvg%3E";
          gridCell.imgSrc = this.svgUrl;
          console.log(gridCell)
          break;
        case "Product Link":
          gridCell.imgSrc = this.svgUrl; // "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='200'%3E%3Crect width='200' height='200' fill='%23ccc'/%3E%3Ctext x='50%' y='50%' font-size='20' text-anchor='middle' fill='%23777' dy='.3em'%3EPlaceholder&nbsp;Banner Big%3C/text%3E%3C/svg%3E'";
          break;

        default:
          break;
      }
    })
    return section
  }

  createMenu(gridCells: GridCell[]) {
    // let menuItems:NbMenuItem = [];

    gridCells.forEach(cell => {
      const menuItemPlaceHolder: MenuItemPlaceHolder = {
        cellId: cell.cellId,
        item: null
      }
      const menuItem: NbMenuItem = {
        title: this.getMenuTitle(cell.contentEnum, "contentEnum"),
        children: this.getChildItems(cell)
      };
      menuItemPlaceHolder.item = menuItem;
      this.menuItemPlaceHolders.push(menuItemPlaceHolder);
      // this.menuItems.push(menuItem);
    })
    console.log(this.menuItems);
    // this.menuService.addItems(this.menuItems,"inputMenu");
  }

  getChildItems(gridCell: GridCell): NbMenuItem[] {
    const items: NbMenuItem[] = [];
    const layoutContext: MenuItemContext = {
      cellId: gridCell.cellId,
      cell: gridCell,
      target: "layout"
    }
    const layoutItem: NbMenuItem = {
      title: 'Cell Layout',
      data: layoutContext
    }
    items.push(layoutItem);
    items.push({ title: "Content Elements", group: true });
    gridCell.contentElements.forEach(el => {
      if (!el.contentElementEnum) {
        console.log("No contentElementEnum: " + el.name);
        switch (el.name) {
          case "Footer":
            el.contentElementEnum = ContentElementEnum.ACTION;
            break;
          case "Text":
            el.contentElementEnum = ContentElementEnum.TEXT;
            break;
          case "Badge":
            el.contentElementEnum = ContentElementEnum.SUB_HEADER;
            break;

          default:
            break;
        }
      }
      const item: NbMenuItem = {
        title: this.getMenuTitle(el.contentElementEnum, "contentElementEnum") || el.name ? el.name : el.elId
      }
      const context: MenuItemContext = {};
      context.elId = el.elId;
      context.contentElement = el;
      context.cellId = gridCell.cellId;
      context.cell = gridCell;
      item.data = context;
      items.push(item);
    })
    return items
  }

  loadResponsive(e) {
    console.log("Nothing happens here", e)
  }

  onSave(e) {
    // 1. Change the statusses of the section and each cell to final draft
    this.section.status = ContentStatusEnum.CTNT_FINAL_DRAFT;
    this.section.sectionData.gridOptions.gridCells.forEach((cell: GridCell) => {
      cell.status = ContentStatusEnum.CTNT_FINAL_DRAFT;
    });
    this.previewEditStoreService.selectedPage$.subscribe(page => {
      console.log(page.pageName);
      if (this.section != undefined && this.section != null) {
        page.sections.push(this.section);
        console.log(page.sections);
        this.previewEditStoreService.updateSelectedPage(page);
        this.previewEditStoreService.updatePageEditState(EditState.UPDATED);
        this.section = null;
      }
      // this.previewEditStoreService.updateEditState(EditState.EDITING);
      this.ref.close();
    })
    // 2. Get the selected Page from the previewStore;
    // 3. Add thgis section to the page;
    // 4. Close the Input dialog

  }

  getMenuTitle(titleEnum, enumType: string) {
    let title;
    if (enumType === "contentEnum") {
      if ((titleEnum).includes(".")) {
        const enumKey = titleEnum.split('.')[1] as keyof typeof ContentEnum;
        title = ContentEnum[enumKey];
      } else if (ContentEnum[titleEnum] != undefined) {
        title = ContentEnum[titleEnum]
      } else {
        title = titleEnum;
      }
    } else if (enumType === "contentElementEnum") {
      if (titleEnum != undefined) {
        if ((titleEnum).includes(".")) {
          const enumKey = titleEnum.split('.')[1] as keyof typeof ContentElementEnum;
          title = ContentElementEnum[enumKey];
        } else if (ContentElementEnum[titleEnum] != undefined) {
          title = ContentElementEnum[titleEnum]
        } else {
          title = titleEnum;
        }
      }

    }

    return title;
  }

  getGridCellContentEnum(gridCell: GridCell) {
    let contentType: string;
    const cntEnum = gridCell.contentEnum;
    if ((cntEnum).includes(".")) {
      const enumKey = cntEnum.split('.')[1] as keyof typeof ContentEnum;
      contentType = ContentEnum[enumKey];
    } else if (ContentEnum[cntEnum] != undefined) {
      contentType = ContentEnum[cntEnum]
    } else {
      contentType = cntEnum;
    }
    return contentType;
  }

  updateSection(e) {
    console.log(e);
    this.section = e;
    if (this.section.status != undefined) {
      this.status = this.section.status;
      this.addMenuItems(this.section, this.menuItemPlaceHolders);
      this.canSave = this.trackCellStatusses(this.section);
      console.log(this.menuItemPlaceHolders);
      this.status$.next(this.section.status);
    }
  }

  addMenuItems(section: Section, menuItemPlaceHolders: MenuItemPlaceHolder[]): void {
    const gridCells: GridCell[] = section.sectionData.gridOptions.gridCells;
    gridCells.forEach(gridCell => {
      if (gridCell.status == "Initial Draft") {
        const placeHolderItem = menuItemPlaceHolders.find(item => item.cellId == gridCell.cellId);
        if (placeHolderItem != undefined) {
          const idx = menuItemPlaceHolders.indexOf(placeHolderItem);
          const placeHolderMenuItems = menuItemPlaceHolders.splice(idx, 1);
          if (placeHolderMenuItems) {
            const nbMenuItems = [];
            nbMenuItems.push(placeHolderMenuItems[0].item);
            this.menuService.addItems(nbMenuItems, "inputMenu");
          }
        }
      }
    })
  }

  trackCellStatusses(section: Section): boolean {
    const statusses = [];
    let canSave = false;
    const gridCells: GridCell[] = section.sectionData.gridOptions.gridCells;
    gridCells.forEach(gridCell => {
      if (gridCell.status) {
        statusses.push(gridCell.status);
      }
    })

    if (statusses.includes(ContentStatusEnum.CTNT_IN_PROGRESS)) {
      canSave = false;
    } else if (statusses.includes(ContentStatusEnum.CTNT_INITIAL_DRAFT) && !statusses.includes(ContentStatusEnum.CTNT_IN_PROGRESS)) {
      canSave = true
    }
    console.log(canSave);
    return canSave;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }


}
